import React, { useContext } from 'react';

import Typography from '@material-ui/core/Typography';
import SearchMenuView from '../SearchMenuView';

import { DropdownMenuContext } from '../SearchDropdown';
import { ROLES } from 'constants/userConstants';

const PeopleMenu = ({ compact }) => {

    const { searchResults, handleClick, handleBlur, displayMode } = useContext(DropdownMenuContext);

    const mapper = {
        [ROLES.EMPLOYEE]: (searchResults) => searchResults.filter(x => x.role === ''),
        [ROLES.SUPPLIER_ADMIN]: (searchResults) => searchResults.filter(x => x.role === ''),
        [ROLES.CLIENT]: (searchResults) => searchResults.filter(x => [ROLES.ADMIN, ROLES.EMPLOYEE].includes(x.role) ? true : [ROLES.SUPPLIER_EMPLOYEE, ROLES.SUPPLIER_ADMIN].includes(x.role) && x.isVetted === true),
        [ROLES.ADMIN]: (searchResults) => searchResults.filter(x => [ROLES.EMPLOYEE, ROLES.ADMIN].includes(x.role)),
        [ROLES.RECRUITER]: (searchResults) => searchResults.filter(x => [ROLES.RECRUITER_EMPLOYEE].includes(x.role))
    };

    const results = compact ? mapper[displayMode](searchResults).slice(0, 3) : mapper[displayMode](searchResults);

    return results.length > 0 ? (
        <div className="search-menu">
            <Typography variant="h5">People</Typography>
            <SearchMenuView
                results={results}
                handleClick={handleClick}
                handleBlur={handleBlur}
            />
        </div>
    ) : null
};

export default PeopleMenu;
